module.exports = __webpack_public_path__ + "img/22_60.1592897f.png";